<template>
  <v-container>

    <v-toolbar flat dense>
      <v-toolbar-title>{{
        project.Project
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon>
        <v-icon>mdi-cog</v-icon>
      </v-btn> -->

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="snackbar_visible = true" v-bind="attrs" v-on="on">
            <v-icon>mdi-download</v-icon>
          </v-btn>
        </template>
        <span>Download PDF </span>
      </v-tooltip>

      <v-menu bottom right offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, i) in menu_items"
            :key="i"
            @click="snackbar_visible = true"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-toolbar>

    <v-card flat class="mb-2">
      <v-card-text>
        {{ this.project.Description }}
        <br /><br />
        <h4>Assumptions / Scope</h4>
        <li
          v-for="(item, index) in project
            .Assumptions"
          :key="index"
        >
          {{ item }}
        </li>
      </v-card-text>
    </v-card>
    <v-card flat rounded="false">
      <v-card-title class="text-subtitle-2">
        Issues
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        class="row-pointer"
        :headers="headers"
        :items="project.Issues"
        :items-per-page="-1"
        :search="search"
        sort-by="Severity"
        sort-desc=True
        @click:row="handleClick"
      >
        <template v-slot:item.Severity="{ item }">
          <v-chip
            small
            class="chip-label text-center"
            label
            text-color="white"
            :color="getLabel(item.Severity).color"
            >{{ getLabel(item.Severity).text }}</v-chip
          >
        </template>
      </v-data-table>
    </v-card>
    <!-- demo toast -->
    <v-snackbar color="error" v-model="snackbar_visible" :timeout="snackbar_timeout">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          plain
          snackbar_text
          v-bind="attrs"
          @click="snackbar_visible = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>
<script>
import router from "../router.js";
import { demoData } from "../a9n-testdata.js";

export default {
  data: () => ({
    snackbar_visible: false,
    snackbar_text: "Demo instance - functionality disabled",
    snackbar_timeout: 2000,
    menu_items: [{ title: "Permissions" }, { title: "Integrations" }],
    search: "",
    labels: [
      {
        name: "high",
        text: "HIGH",
        color: "issueHigh",
      },
      {
        name: "medium",
        text: "MEDIUM",
        color: "issueMedium",
      },
      {
        name: "low",
        text: "LOW",
        color: "issueLow",
      },
      {
        name: "info",
        text: "INFO",
        color: "issueInfo",
      },
    ],
    headers: [
      // { text: "No", value: "IID" , width: "8%"},
      {
        text: "Severity",
        value: "Severity",
        width: "15%",
        sort: function(a,b) {
          const order = ["High", "Medium", "Low", "Info"]
          const apos = order.indexOf(a)
          const bpos = order.indexOf(b)
          if (apos == bpos) {
            return 0
          }
          else if (apos < bpos) {
            return 1
          }
          else {
            return -1
          }
        }
      },
      { text: "Name", value: "Title" },
      { text: "Category", value: "Category" },
      { text: "Vector", value: "Vector" },
      { text: "Privilege", value: "Privilege", width: "10%" },
    ],
  }),
  methods: {
    handleClick(item) {
      router.push({
        name: "issuedetail",
        params: {
          assessmentId: this.$route.params.assessmentId,
          issueId: item.IID,
        },
      });
    },
    getLabel(text) {
      // TODO use common/labels.js
      if (typeof text === "string") {
        return this.labels.find(({ name }) => name === text.toLowerCase());
      }
    },
  },
  computed: {
    project() {
      return demoData.Projects[this.$route.params.assessmentId -1]
    } 
  },
  created() { },
};
</script>
<style lang="css" scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.chip-label {
  width: 80px;
  font-weight: bold;
  justify-content: center;
}
</style>
